import { Send } from "lucide-react";

export default function MessageInput({ value, onChange, onSubmit, busy }) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="flex border-t border-white/10"
      data-testid="chat-form"
    >
      <input
        data-testid="chat-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Ask about classes, booking, gear..."
        className="flex-1 bg-[#0A0A0A] px-4 py-3 text-sm text-white placeholder:text-zinc-500 focus:outline-none"
      />
      <button
        data-testid="chat-send"
        type="submit"
        disabled={busy}
        className="bg-[#7CFF00] text-black px-4 disabled:opacity-50 hover:bg-[#65CC00] transition-colors"
        aria-label="Send"
      >
        <Send className="w-4 h-4" />
      </button>
    </form>
  );
}
